import { FC, useCallback, useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import Dropzone from "react-dropzone";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  IconButton,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Spinner,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { Field } from "react-final-form";
import { string } from "yup/lib/locale";
import { NoPic } from "../../../../assets/fonts/icons";
import { DeleteIcon } from "@chakra-ui/icons";
import { API_URL } from "../../../httpClient/constants";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const CustomInput: FC<any> = (props) => {
  // console.log("CustomInput props: ", props);
  const { name, label, meta, input, placeholder, onChangeDate } = props;
  return (
    <FormControl isInvalid={meta.error && meta.touched}>
      <FormLabel
        htmlFor={name}
        sx={{
          fontWeight: "700",
          fontSize: "10px",
          lineHeight: "12px",
          color: "#A6A8AE",
        }}
      >
        {label} {input.value}
      </FormLabel>
      <Input
        {...input}
        value={
          input.type === "date" && dayjs(input.value, "DD.MM.YYYY").isValid()
            ? dayjs(input.value, "DD.MM.YYYY").format("YYYY-MM-DD")
            : input.value
        }
        isInvalid={meta.error && meta.touched}
        onChange={(arg) => {
          input.onChange(arg);
          if (typeof onChangeDate === "function") {
            onChangeDate(dayjs(arg.target.value).format("DD.MM.YYYY"));
          }
        }}
        id={name}
        placeholder={placeholder}
        sx={{
          height: "47px",
          padding: "15px 20px",
          gap: "10px",
          background: "#FFFFFF",
          border: "1px solid #D2D4D7",
        }}
      />
      {/* {input.value ? (
      ) : (
        <Spinner />
      )} */}
      <FormErrorMessage>{meta.error}</FormErrorMessage>
    </FormControl>
  );
};

export const CustomPasswordInput = ({
  name,
  label,
  meta,
  input,
  placeholder,
}) => {
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);
  return (
    <>
      <FormControl isInvalid={meta.error && meta.touched}>
        <FormLabel htmlFor={name}>{label}</FormLabel>
        <InputGroup size="md">
          <Input
            pr="4.5rem"
            {...input}
            isInvalid={meta.error && meta.touched}
            id={name}
            placeholder={placeholder}
            type={show ? "text" : "password"}
          />
          <InputRightElement width="4.5rem">
            <Button h="1.75rem" size="sm" onClick={handleClick}>
              {show ? "Hide" : "Show"}
            </Button>
          </InputRightElement>
        </InputGroup>
        <FormErrorMessage>{meta.error}</FormErrorMessage>
      </FormControl>
    </>
  );
};

const DropzoneComp = (props) => {
  const [files, setFiles] = useState([]);

  const { getRootProps, getInputProps } = useDropzone({
    multiple: !!props.multiple,
    onDrop: (acceptedFiles) => {
      console.log("onDrop acceptedFiles", acceptedFiles);

      if (acceptedFiles.length > 0) {
        const filesWithPreview = acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          }),
        );
        setFiles(filesWithPreview);

        if (props.onChange) {
          props.onChange(acceptedFiles);
        }
      }
    },
  });

  const removeFile = (file) => () => {
    const newFiles = [...files];
    newFiles.splice(newFiles.indexOf(file), 1);
    setFiles(newFiles);
  };

  const thumbs = files.map((file) => (
    <Box
      sx={{ position: "relative" }}
      key={file.name}
      width={"355px"}
      margin={"20px"}
    >
      <Image src={file.preview} alt={file.name} height={"233px"} />
      <Flex
        flexDirection="row"
        alignItems={"center"}
        justifyContent="space-around"
        width="100%"
        sx={{
          position: "absolute",
          bottom: "20px",
          left: "0",
        }}
      >
        <IconButton
          aria-label="Delete pics"
          onClick={removeFile(file)}
          icon={<DeleteIcon />}
          width="26px"
          height="26px"
        />
      </Flex>
    </Box>
  ));

  useEffect(() => {
    return () => {
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    };
  }, [files]);

  return (
    <div className="d-inline-block mt-4">
      <Flex alignItems={"flex-start"}>
        <div>
          <Text
            sx={{
              fontWeight: "700",
              fontSize: "10px",
              lineHeight: "12px",
              color: "#A6A8AE",
              marginBottom: "20px",
            }}
          >
            {props.label}
          </Text>
          <Box
            {...getRootProps()}
            sx={{
              width: props.fullwidth ? "800px" : "350px",
              height: "233px",
              background: "#FFFFFF",
              border: "1px dashed #E0E3E7",
              borderRadius: "5px",
            }}
          >
            <Flex
              height="100%"
              flexDirection={"column"}
              alignItems="center"
              justifyContent="center"
              gap="20px"
            >
              <img src={NoPic} width="56px" height="56px" />
              <Text
                sx={{
                  width: "190px",
                  textAlign: "center",
                  fontWeight: "700",
                  fontSize: "10px",
                  lineHeight: "150%",
                  color: "#A6A8AE",
                }}
              >
                Перетащите сюда изображение или кликните, чтобы выбрать файл из
                файловой системы
              </Text>
              <input {...getInputProps()} multiple={props.multiple} />
            </Flex>
          </Box>
        </div>

        {typeof props.intialPreview === "string" && !!props.intialPreview && (
          <div style={{ marginLeft: 30 }}>
            <Text
              sx={{
                fontWeight: "700",
                fontSize: "10px",
                lineHeight: "12px",
                color: "#A6A8AE",
                marginBottom: "20px",
              }}
            >
              Текущее изображение
            </Text>
            <Box
              sx={{
                width: "350px",
                height: "233px",
                background: "#FFFFFF",
                border: "1px dashed #E0E3E7",
                borderRadius: "5px",
                overflow: "hidden",
              }}
            >
              <a
                target="_blank"
                href={`${process.env.REACT_APP_API_URL}/${props.intialPreview}`}
              >
                <img
                  src={`${process.env.REACT_APP_API_URL}/${props.intialPreview}`}
                  height="233px"
                />
              </a>
            </Box>
          </div>
        )}
      </Flex>
      <Flex marginLeft={"-20px"} marginRight={"-20px"}>
        {thumbs}
      </Flex>
    </div>
  );
};

export const DonwloadComponentNew = ({
  name,
  intialPreview,
  multiple,
  label,
  fullwidth,
}) => {
  return (
    <Field name={name}>
      {(props) => (
        <div style={{ width: "100%" }}>
          <DropzoneComp
            {...props.input}
            intialPreview={intialPreview}
            multiple={multiple}
            label={label}
            fullwidth={fullwidth}
          />
          <Text
            sx={{
              fontWeight: "700",
              fontSize: "10px",
              lineHeight: "12px",
              color: "red",
              marginBottom: "20px",
            }}
          >
            Не более 5 мб
          </Text>
        </div>
      )}
    </Field>
  );
};

export const DonwloadComponent = ({
  name,
  label,
  multiple,
  srcPic,
  url,
  onClick,
  disabled,
}: {
  name: string;
  label: string;
  multiple?: boolean;
  srcPic?: any;
  url?: string;
  onClick?: () => void;
  disabled?: any;
}) => {
  const [src, setSrc] = useState(srcPic);
  const deleteSrc = () => {
    setSrc("");
  };
  return (
    <>
      <Text
        sx={{
          fontWeight: "700",
          fontSize: "10px",
          lineHeight: "12px",
          color: "#A6A8AE",
        }}
      >
        {label}
      </Text>
      {src && typeof src === "string" ? (
        <Box sx={{ position: "relative" }}>
          <Image src={`${url}/${srcPic}`} alt={name} />
          <Flex
            flexDirection="row"
            alignItems={"center"}
            justifyContent="space-around"
            width="100%"
            sx={{
              position: "absolute",
              bottom: "20px",
              left: "0",
            }}
          >
            <Button
              onClick={onClick}
              disabled={disabled}
              sx={{
                width: "67px",
                height: "26px",
                background: "#fff",
                borderRadius: "5px",
                fontWeight: "700",
                fontSize: "10px",
                lineHeight: "12px",
                color: "#55769D",
              }}
            >
              Скачать
            </Button>
            <IconButton
              aria-label="Delete pics"
              onClick={deleteSrc}
              icon={<DeleteIcon />}
              width="26px"
              height="26px"
            />
          </Flex>
        </Box>
      ) : (
        <Field
          name={name}
          component={(props) => (
            <DownloadFiles {...props} multiple={multiple} />
          )}
        />
      )}
    </>
  );
};

const DownloadFiles = ({ input, multiple }) => {
  const [images, setImages] = useState<any>();

  const onDrop = useCallback(
    (acceptedFiles) => {
      input.onChange(acceptedFiles); // если убрать эту хуйню, то изображение выводится, но не отправляется на сервак
      setImages(acceptedFiles.map((file) => URL.createObjectURL(file)));
    },
    [setImages],
  );
  const { acceptedFiles, getRootProps, getInputProps, isDragActive } =
    useDropzone({
      onDrop,
    });
  return (
    <Box
      {...getRootProps()}
      sx={{
        width: "350px",
        height: "233px",
        background: "#FFFFFF",
        border: "1px dashed #E0E3E7",
        borderRadius: "5px",
      }}
    >
      {images ? (
        <img alt="" src={images} />
      ) : (
        <Flex
          height="100%"
          flexDirection={"column"}
          alignItems="center"
          justifyContent="center"
          gap="20px"
        >
          <img src={NoPic} width="56px" height="56px" />
          <Text
            sx={{
              width: "190px",
              textAlign: "center",
              fontWeight: "700",
              fontSize: "10px",
              lineHeight: "150%",
              color: "#A6A8AE",
            }}
          >
            Перетащите сюда изображение или кликните, чтобы выбрать файл из
            файловой системы
          </Text>
          <input {...getInputProps()} multiple={multiple} />
        </Flex>
      )}
    </Box>
  );
};

export const DownloadFile = ({ name, label, ...props }) => {
  const inputRef = useRef<HTMLInputElement>();
  const onDrop = useCallback(
    (acceptedFiles, rejected, { dataTransfer: { files } }) => {
      // console.log("input ref", inputRef.current);
      // Do something with the files
      inputRef.current.files = files;
      inputRef.current.dispatchEvent(new Event("change"));
      //@ts-ignore
      window.form.mutators.setValue(name, files);
      // console.log("onDrop", files, inputRef.current.files);
    },
    [],
  );
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop,
  });
  const files = acceptedFiles?.map((file) => (
    <li key={file.name}>{file.name}</li>
  ));

  return (
    <Box w="100%" p={4} boxShadow="lg">
      <FormControl {...getRootProps()}>
        <FormLabel htmlFor={name}>{label}</FormLabel>
        <Field
          name={name}
          component={({ input: { value, onChange, ...input } }) => (
            <input
              {...input}
              type="file"
              onChange={({ target }) => onChange(target.files)}
              {...props}
              {...getInputProps()}
              ref={inputRef}
            />
          )}
        />

        <p>
          Переместите сюда файл, чтобы добавить или редактировать изображение /
          видео
        </p>
        <aside>
          <h4>Files</h4>
          <ul>{files}</ul>
        </aside>
      </FormControl>
    </Box>
  );
};

export const CustomTextArea: FC<any> = ({
  name,
  label,
  meta,
  input,
  placeholder,
}) => {
  return (
    <FormControl isInvalid={meta.error && meta.touched}>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <Textarea
        {...input}
        isInvalid={meta.error && meta.touched}
        id={name}
        placeholder={placeholder}
      />
      <FormErrorMessage>{meta.error}</FormErrorMessage>
    </FormControl>
  );
};
